import { JDMta } from '@jdreact/jdreact-core-lib';
import { Platform } from 'react-native';
/* eslint camelcase: "off" */
/* globals MPing */

const sendClickDataWithJsonParamForWeb = function(eventId, event_param, page_id, page_param, json_param, webDelayTime = 300, ext) {
    const sendData = new Promise((resolve) => {
        if (Platform.OS !== 'web' || typeof MPing === 'undefined') {
            return resolve();
        }
        try {
            var click = new MPing.inputs.Click(eventId); // 构造click 请求
            click.event_param = event_param; // 设置click的参数
            click.page_id = page_id;
            click.extend_field = ext;
            click.page_param = page_param; // 设置click的参数
            click.json_param = json_param;
            click.updateEventSeries(); // 更新事件串
            var mping = new MPing(); // 构造上报实例
            mping.send(click, resolve); // 上报click
        } catch (e) {
            resolve();
        }
    });
    const timeout = new Promise((resolve) => {
        setTimeout(resolve, webDelayTime);
    });
    return Promise.race([sendData, timeout]);
};

export function sendClickData({
    event_id = '',
    event_param = '',
    event_func = 'onClick',
    page = '',
    page_param = '',
    next_page_param = '',
    page_id = 'pageId',
    shop_id = ''
}) {
    JDMta.sendClickData(
        event_id,
        `${event_param}`,
        event_func,
        page,
        page_param,
        next_page_param,
        page_id,
        shop_id
    ).catch((e) => {
        console.log(e);
    });
}

export async function sendClickDataWithJsonParam({
    event_id = '',
    event_param = '',
    event_func = 'onClick',
    page = '',
    page_param = '',
    next_page_param = '',
    page_id = '',
    shop_id = '',
    json_param = {},
    webDelayTimt = 100,
    ext = {}
}) {
    if (Platform.OS === 'web') {
        sendClickDataWithJsonParamForWeb(event_id, event_param, page_id, page_param, JSON.stringify(json_param), webDelayTimt, JSON.stringify(ext));
    } else {
        JDMta.sendClickDataWithJsonParam(
            event_id,
            event_param,
            event_func,
            page,
            page_param,
            next_page_param,
            page_id,
            shop_id,
            JSON.stringify(json_param) === '{}' ? '' : JSON.stringify(json_param),
            '',
            '',
            '',
            webDelayTimt,
            ext
        ).catch(e => {
            console.log(e);
        });
    }
}

export const sendExposureData = async({
    event_id = '',
    event_param = '',
    page_id = '',
    page = '',
    json_param = {},
    page_param = '',
    webDelayTimt = 100,
    ext = {}
}) => {
    if (Platform.OS === 'web') {
        sendClickDataWithJsonParamForWeb(event_id, event_param, page_id, page_param, JSON.stringify(json_param), webDelayTimt, JSON.stringify(ext));
    } else {
        try {
            JDMta.sendExposureDataWithJsonParam(
                `${page}`,
                `${page_id}`,
                page_param,
                `${event_id}`,
                event_param,
                '',
                '',
                '',
                '',
                '',
                JSON.stringify(json_param),
                '',
                `${webDelayTimt}`,
                ext
            );
        } catch (error) {}
    }
};

// PV埋点
export const sendPv = ({ pageId = '', pageName = '', pageParam = '' }) => {
    if (Platform.OS === 'web') {
        JDMta.isReportDefaultPageParam = false;
    }
    try {
        JDMta.sendPvData(`${pageName}`, `${pageParam}`, `${pageId}`, '');
    } catch (error) {
        console.log(error);
    }
};
